// src/services/marketingDashboard.service.js
import { request } from "./http";

const base = "/MarketingDashboard";

const qs = (obj = {}) => {
  const params = new URLSearchParams();
  Object.entries(obj).forEach(([k, v]) => {
    if (v === undefined || v === null || v === "") return;
    params.set(k, String(v));
  });
  const s = params.toString();
  return s ? `?${s}` : "";
};

export function getStatistics() {
  return request(`${base}/statistics`, { method: "GET", auth: true });
}

export function getClientGrowth(months = 6) {
  return request(`${base}/client-growth${qs({ months })}`, { method: "GET", auth: true });
}

export function getCampaignPerformance(topN = 10) {
  return request(`${base}/campaign-performance${qs({ topN })}`, { method: "GET", auth: true });
}

export function getTopClients(topN = 10) {
  return request(`${base}/top-clients${qs({ topN })}`, { method: "GET", auth: true });
}

export function getRecentActivity(days = 7) {
  return request(`${base}/recent-activity${qs({ days })}`, { method: "GET", auth: true });
}

export const marketingDashboardService = {
  getStatistics,
  getClientGrowth,
  getCampaignPerformance,
  getTopClients,
  getRecentActivity,
};
